import * as durationHelper from '../../helpers/duration-handler';
import Routing from '../../core/router/router';
import { HTTP } from '../../core/http/http-token';
import i18n from '../../i18n';

const state = {
  listSelected: [],
  template: {},
  all: [],
  duplicateScreen:null,
  selected: [],
  current: {
    assets: '',
    components: '',
    css: '',
    html: '',
    options: {
      duration: durationHelper.totalSegmentDuration(),
    },
    styles: '',
    title: 'Disposition vierge',
    transition: {
      in: '',
      out: '',
    },
    type: 'Segment',
    screenShot:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJAQMAAAAB5D5xAAAABlBMVEXs7vHs7/Hee24nAAAAFUlEQVQI12P4/58BiGrB5D8wCUX/AOfxEWuWlIcVAAAAAElFTkSuQmCC',
    id: 0,
    uid: 100,
  },
  loading: false,

  currentPage: {
    Screen: 1,
    Disposition: 1,
  },
  nbPerPage: 32,
  endReached: {
    Screen: false,
    Disposition: false,
  },
  delay: 0,
  opacity: 100,
  nbSlides: 0,
};

const mutations = {
  setSlides(state, data) {
    state.slides = data;
  },
  selectTemplate(state, data) {
    state.template = { ...state.template, ...data };
  },
  pushSlides(state, slides) {
    let slidesTmp = slides.map(s => {
      if (!s.screenShot) {
        s.screenShot =
          'data:image/png;base64,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';
      }
      return s;
    });

    state.all = state.all.concat(slidesTmp);
  },
  selectSlide(state, slide) {
    const props = {
      uid: Math.floor(new Date().valueOf() * Math.random()),
      options: {
        duration: durationHelper.totalSegmentDuration(),
      },
      transition:
        slide.options.transition && slide.options.transition.length > 0
          ? slide.options.transition
          : { in: '', out: '' },
      js: slide.html.substring(slide.html.indexOf('<script>') + 8, slide.html.indexOf('</script>')),
      ...slide,
    };
    if (slide.type === 'images') {
      props.type = 'images';
    } else {
      props.type = 'Screen';
    }
    state.selected.push(props);
    state.selected = durationHelper.updateSlidesDuration(state.selected);
  },

  pushListSelected(state, data) {
    state.listSelected.push(data);
  },
  resetListSelected(state) {
    state.listSelected = [];
  },
  duplicateSlide(state, { slide, index }) {
    index += state.selected.findIndex(s => s.type === 'startGeneric') + 1;

    const props = {
      title: slide.title + '(copie)',
      uid: new Date().valueOf(),
      options: {
        duration: slide.options.duration,
      },
      transition: {
        in: slide.transition.in,
        out: slide.transition.out,
      },
    };
    state.selected.splice(
      index + 1,
      0,
      Object.assign({}, JSON.parse(JSON.stringify(slide)), props),
    );
    state.duplicateScreen=Object.assign({}, JSON.parse(JSON.stringify(slide)), props);
      state.selected = durationHelper.updateSlidesDuration(state.selected);
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  incrementPage(state, type) {
    state.currentPage[type] += 1;
  },
  setEndReached(state, { type, endReached }) {
    state.endReached[type] = endReached;
  },
  setSlideDuration(state, data) {
    state.selected = state.selected.map(slide => {
      if (slide.uid === data.uid) {
        slide.options.duration = data.duration;
      }
      return slide;
    });
  },
  setSlideTransition(state, data) {
    const transitionIndex = state.selected.findIndex(slide => slide.uid === data.uid);

    state.selected = state.selected.map((slide, index) => {
      if (index === transitionIndex - 1) {
        slide.transition.out = data.name + '-out';
      } else if (index === transitionIndex) {
        slide.transition.in = data.name + '-in';
      }
      return slide;
    });
  },
  setScreensTosubmit(state, data) {
    state.selected.map(screen => {
      if (screen.uid === data.uid) {
        screen.template = data.template;
        screen.type = data.type;
        if(typeof screen.options == "string")
        {
          screen.options = JSON.parse(screen.options);
        }
        screen.options.transition = data.transition;
        screen.screenShot = data.screenShot;
      }
      return screen;
    });

  },
  updateSlide(state, data) {
    state.selected = state.selected.map((slide, index) => {
      if (slide.uid === data.uid) {
        state.selected[index].components = data.components || '';
        state.selected[index].html = data.html || '';
        state.selected[index].css = data.css || '';
        state.selected[index].styles = data.styles || '';
        state.selected[index].js = data.js || '';
      }
      return slide;
    });
  },
  removeSlideByUid(state, uid) {
    state.selected = state.selected.filter(slide => slide.uid !== uid);
    state.selected = durationHelper.updateSlidesDuration(state.selected);
  },
  removeLastSlideById(state, id) {
    const index = state.selected
      .slice()
      .reverse()
      .findIndex(slide => slide.id === id);
    const count = state.selected.length - 1;
    const finalIndex = index >= 0 ? count - index : index;
    state.selected = state.selected.filter((slide, i) => slide.id !== id);
    state.selected = durationHelper.updateSlidesDuration(state.selected);
  },

  removeFromListSelected(state, id) {
    state.listSelected = state.listSelected.filter(s => s.id !== id);
  },

  existanceSlide(state, title) {
    HTTP(window.ApiToken)
      .get(Routing.generate('api_slideDisplay_get_existant_slide'), {
        title: title,
      })
      .then(function(response) {
        return response.data.existance;
      });
  },
  setCurrentSlide(state, current) {
    state.current = current;
  },
  reorderSlides(state, event) {
    let { oldIndex, newIndex } = event;

    const i = state.selected.findIndex(s => s.type === 'startGeneric') + 1;

    oldIndex += i;
    newIndex += i;

    const movedItem = state.selected.find((item, index) => index === oldIndex);
    const remainingItems = state.selected.filter((item, index) => index !== oldIndex);

    state.selected = [
      ...remainingItems.slice(0, newIndex),
      movedItem,
      ...remainingItems.slice(newIndex),
    ];
  },
  updateSlideTitle(state, data) {
    state.selected = state.selected.map(slide => {
      if (slide.uid === data.uid) {
        slide.title = data.title;
      }
      return slide;
    });
  },
  updateSlideDuration(state, data) {
    state.selected = state.selected.map(slide => {
      if (slide.uid === data.uid) {
        slide.options.duration = data.duration;
      }
      return slide;
    });
  },
  updateSlideThumbnail(state, data) {
    state.selected = state.selected.map(slide => {
      if (slide.uid === data.uid) {
        slide.screenShot = data.thumbnail;
      }
      return slide;
    });
  },
  updateSlideTitleGlobally(state, data) {
    state.all = state.all.map(slide => {
      if (slide.id === data.id) {
        slide.title = data.title;
      }
      return slide;
    });
  },
  setDelayFragment(state, delay) {
    state.delay = delay;
  },
  setDispositions(state, data) {
    state.all = data;
  },
  setOpacityFragment(state, opacity) {
    state.opacity = opacity;
  },
  changeTitleInSelected(state, title) {
    state.selected[0].title = title;
  },
  setSlidesGeneric(state, slide) {
    let html = `<iframe class="gjs-no-pointer" src="${
      slide.src
    }?a=1&sc=0" id="player-677" width="100%" height="100%" scrolling="no"  allow="encrypted-media" style="border: none; overflow: hidden;"></iframe>`;
    let extension = slide.src.split('.').pop();
    if (extension.toLowerCase().indexOf('mp4') > -1) {
      html = `<video data-autoplay class="gjs-no-pointer" src="${
        slide.src
      }" id="player-677" width="100%" height="100%" scrolling="no" muted autoplay allow="encrypted-media" style="border: none; overflow: hidden;"></video>`;
    }
    let generic = {
      html,
      type: slide.type,
      components: '',
      css: '',
      js: '',
      options: {
        duration: durationHelper.totalSegmentDuration(),
      },
      screenShot: '',
      transition: { in: '', out: '' },
      ...slide,
    };
    const selected = state.selected.filter(slide => slide.type !== generic.type);
    if (generic.type.toLowerCase().includes('start')) {
      if (generic.src !== '') {
        selected.unshift(generic);
      }
    } else {
      if (generic.src !== '') {
        selected.push(generic);
      }
    }
    state.selected = durationHelper.updateSlidesDuration(selected);
  },
  resetSelect(state) {
    state.selected = [];
  },
  updatePogramTitle(state, title) {
    state.template.title = title;
  },
  resetPage(state, types) {
    state.currentPage[types] = 1;
  },
  nbSegments(state, nb) {
    state.nbSegments = nb;
  },
};

const actions = {
  async selectImage({ state, commit }, media) {
    function makeId() {
      var text = 'i';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    }
    let html =
      `<div data-gjs-type="image_media" id="` +
      makeId() +
      `" width="100%" height="100%"><image class="gjs-no-pointer" src="${
        media.selected.src
      }" id="image-media-` +
      makeId() +
      `" width="100%" height="100%" scrolling="no" allow="encrypted-media" style="border: none; overflow: hidden;"></image></div>`;
    const domc = grapesjsEMP.editors[0].DomComponents;
    const defaultType = domc.getType('default');
    const defaultModel = defaultType.model;
    // const defaultView = defaultType.view;
    let components = {
      'custom-name': 'image',
      tagName: 'div',
      src: media.selected.src,
      width: '100%',
      height: '100%',
      resizable: false,
      selected: true,
      attributes: {
        id: +makeId(),
        'data-class': 'image-media',
      },
      classes: [
        {
          active: true,
          label: makeId(),
          name: makeId(),
          private: false,
          protected: false,
          type: 1,
        },
        {
          active: true,
          label: 'gjs-comp-selected',
          name: 'gjs-comp-selected',
          private: false,
          protected: false,
          type: 1,
        },
      ],
      type: '',
      draggable: true,
      droppable: false,
      editable: false,
      highlightable: true,
      hoverable: true,
      icon: '',
      layerable: true,
      name: '',
      propagate: '',
      removable: true,
      script: '',
      selectable: true,
      config: {
        translate: i18n.t('display-image-plugin'),
      },
      'data-class': 'image-media',
      badgable: true,
      components: [],
      content: '',
      copyable: true,
      state: '',
      status: '',
    };
    let fullscreenVideo = false;
    let slide = {
      html,
      type: media.type,
      components: JSON.stringify(components),
      css: '',
      js: '',
      options: { fullscreenVideo },
      screenShot: media.selected.src,
      transition: { in: '', out: '' },
      ...media.selected,
    };

    commit('selectSlide', slide);
    commit('pushListSelected', slide);
  },

  async paginate({ commit }, type) {
    if (!state.endReached[type]) {
      commit('setLoading', true);

      const url = Routing.generate('api_screenDisplay_get_all_disposition', {
        page: state.currentPage[type],
        nbParPage: state.nbPerPage,
        type: type,
        client: localStorage.getItem('client')
      });
      const { data } = await new Promise((resolve, reject) => {
        HTTP(window.ApiToken)
          .get(url)
          .then(function(response) {
            resolve(response);
          });
      });

      data.data.dispositions.map(screen => {
        if (!screen.options) {
          screen.options = durationHelper.totalSegmentDuration();
        }
        let newData = JSON.parse(screen.options);
        screen.options = newData;
      });
      commit('incrementPage', type);
      commit('pushSlides', data.data.dispositions);
      commit('nbSegments', data.data.nombre_total);
      if (data.data.dispositions.length < state.nbPerPage) {

        commit('setEndReached', { type, endReached: true });
      } else {
        commit('setEndReached', { type, endReached: false });
      }
      commit('setLoading', false);
    }
  },
  async updateTitle({ state, commit }, data) {
    HTTP(window.ApiToken)
      .post(Routing.generate('api_screenDisplay_post_edit_screen', { id: data.id }), {
        title: data.title,
      })
      .then(function(response) {
        commit('updateSlideTitleGlobally', data);
      });
  },
  setTemplate({ commit }, template) {
    commit('selectTemplate', template);
  },
  setTemplateCurrent({ commit }, template) {
    commit('selectTemplate', template);
  },
  setScreensTosubmit: ({ state, commit }, data) => commit('setScreensTosubmit', data),
  setSlides: ({ state, commit }, slides) => commit('setSlides', slides),
  selectSlide: ({ state, commit }, slide) => commit('selectSlide', slide),
  duplicateSlide: ({ state, commit }, { slide, index }) =>
    commit('duplicateSlide', { slide, index }),
  setSlideDuration: ({ state, commit }, slide) => commit('setSlideDuration', slide),
  setDispositions: ({ state, commit }, data) => commit('setDispositions', data),
  pushListSelected: ({ state, commit }, data) => commit('pushListSelected', data),
  resetListSelected: ({ state, commit }) => commit('resetListSelected'),
  setSlideTransition: ({ state, commit }, slide) => commit('setSlideTransition', slide),
  updateSlide: ({ state, commit }, slide) => commit('updateSlide', slide),
  updateSlideTitle: ({ state, commit }, slide) => commit('updateSlideTitle', slide),
  updateSlideDuration: ({ state, commit }, slide) => commit('updateSlideDuration', slide),
  updateSlideThumbnail: ({ state, commit }, slide) => commit('updateSlideThumbnail', slide),
  removeSlideByUid: ({ state, commit }, uid) => commit('removeSlideByUid', uid),
  removeLastSlideById: ({ state, commit }, id) => commit('removeLastSlideById', id),
  removeFromListSelected: ({ state, commit }, id) => commit('removeFromListSelected', id),
  pushSlides: ({ state, commit }, slide) => commit('pushSlides', slide),
  setCurrentSlide: ({ state, commit }, slide) => commit('setCurrentSlide', slide),
  reorderSlides: ({ state, commit }, event) => commit('reorderSlides', event),
  setSlidesGeneric: ({ state, commit }, slide) => commit('setSlidesGeneric', slide),
  changeTitleInSelected: ({ state, commit }, title) => commit('changeTitleInSelected', title),
  setDelayFragment({ commit }, delay) {
    commit('setDelayFragment', delay);
  },
  setOpacityFragment({ commit }, opacity) {
    commit('setOpacityFragment', opacity);
  },
  resetSelect: ({ state, commit }) => commit('resetSelect'),
  updatePogramTitle: ({ state, commit }, title) => commit('updatePogramTitle', title),
  resetPage({ state, commit }, types) {
    commit('resetPage', types);
  },
};

// getters are functions
const getters = {
  getLoading: state => state.loading,
  getduplicateScreen: state => state.duplicateScreen,
  getListSelected: state => state.listSelected,
  getEndReached: state => type => state.endReached[type],
  getAll: state => state.all,
  getAllScreens: state => state.all.filter(s => s.type === 'screen'),
  getAllDispositions: state => state.all.filter(s => s.type === 'Disposition'),
  getSelected: state =>
    state.selected.filter(slide => !slide.type.toLowerCase().includes('generic')),
  getAllSelected: state => state.selected,
  isSelected: state => slide => state.selected.some(s => s.uid === slide.uid),
  getSlideByUid: state => uid => state.selected.find(item => item.uid === uid),
  getLastSlideById: state => id =>
    state.selected
      .slice()
      .reverse()
      .find(slide => slide.id === id),
  getCurrent: state => state.current,
  getByIndex: state => index => state.selected.find((s, i) => i === index),
  getSlideIndex: state => slide =>
    state.selected
      .filter(slide => !slide.type.toLowerCase().includes('generic'))
      .findIndex(s => s.uid === slide.uid),
  getTemplateTitle: state => state.template.title,
  getDelayFragment: state => state.delay,
  getOpacityFragment: state => state.opacity,
  getTemplate: state => state.template,
  getCurrentSlideIndex: state => state.selected.findIndex(s => state.current.uid === s.uid),
  getStartGeneric: state => state.selected.find(s => s.type === 'startGeneric'),
  getFinishGeneric: state => state.selected.find(s => s.type === 'finishGeneric'),
  getAllScreensDuration: state => {
    /* todo -2s */
    return state.selected.reduce((sum, e) => sum + +(e.options.duration || 0), 0);
  },
  getNbSlides: state => state.nbSlides,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/slides-data.js